import React, { useEffect } from 'react';
import { Translation } from 'react-i18next';
import { Form, Select } from 'antd';
import { CrownOutlined } from '@ant-design/icons';

const TagInput = ({
  name,
  label,
  options,
  options_partner,
  list,
  list_partner,
  combinedList = [],
  load,
  loadPartnerTags,
  activeId,
  onChange = null,
  rules = null,
  placeholder = null,
  form,
  selectDefaults = false, // <- NUEVO
  ...props
}) => {
  useEffect(() => {
    load();
    loadPartnerTags(activeId, 1, 500);
  }, [load, loadPartnerTags, activeId]);

  useEffect(() => {
    if (selectDefaults && form) {
      const defaultValues = [
        ...list.filter((x) => x.is_default).map((x) => `${x.id}.tag`),
        ...list_partner
          .filter((x) => x.is_default)
          .map((x) => `${x.id}.partner_tag`),
      ];
      if (defaultValues.length > 0) {
        form.setFieldsValue({ [name]: defaultValues });
      }
    }
  }, [selectDefaults, list, list_partner, form, name]);

  return (
    <Translation>
      {(t) => (
        <div className='form-group'>
          <Form.Item
            name={name}
            label={label ? label : t('journal_posts_form_input_tags')}
            rules={rules}
          >
            <Select
              showSearch
              mode='multiple'
              disabled={
                props.isLoading ||
                props.isSubmitting ||
                props.isLoadingPartnerTags
              }
              loading={props.isLoading}
              onChange={onChange}
              showArrow={true}
              placeholder={placeholder}
            >
              {combinedList.map((x) => {
                const key = x.isPartnerTag ? `${x.id}.partner_tag` : `${x.id}.tag`;
                const value = key;

                return (
                  <Select.Option key={key} value={value}>
                    {x.label} {x.isPartnerTag && <CrownOutlined />}
                  </Select.Option>
                );
              })}
            </Select>
          </Form.Item>
        </div>
      )}
    </Translation>
  );
};

export default TagInput;
